import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';
import {createBrowserHistory} from 'history';
import wrap from 'wraptile';
import {routerMiddleware} from 'connected-react-router';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import promise from 'redux-promise';
import createSagaMiddleware from 'redux-saga';
import {identity} from '@pluto/utils';
import {unauthorizedLogout} from '@pluto/unauthorized-logout';
import rootSaga from 'rootSaga';
import createRootReducer from './rootStore';

const getColor = wrap(identity);
const logger = createLogger({
    duration: true,
    collapsed: true,
    colors: {
        title: getColor('#139BFE'),
        prevState: getColor('#1C5FAF'),
        action: getColor('#149945'),
        nextState: getColor('#AF5C1C'),
        error: getColor('#ff0005'),
    },
});

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

const extensions = [promise, unauthorizedLogout, thunk, sagaMiddleware];

if (process.env.NODE_ENV !== 'production') {
    extensions.push(logger);
}

const middleware = composeWithDevTools(
    applyMiddleware(routerMiddleware(history), ...extensions)
);

export const configureStore = () => {
    const store = createStore(createRootReducer(history), middleware);

    sagaMiddleware.run(rootSaga);

    return store;
};
